/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SavingsPlanUtilizationData extends models.SavingsPlanBase {
    getFixupPrototypeFunction() { return SavingsPlanUtilizationData.fixupPrototype; }

    static newInstance(model: Partial<SavingsPlanUtilizationData>): SavingsPlanUtilizationData {
        let obj = Object.assign(new SavingsPlanUtilizationData(), model);
        SavingsPlanUtilizationData.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SavingsPlanUtilizationData>): SavingsPlanUtilizationData {
        if (!model) return null;
        return SavingsPlanUtilizationData.newInstance(<SavingsPlanUtilizationData> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SavingsPlanUtilizationData) {
        if (!obj) return;

        models.SavingsPlanUtilizationData.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SavingsPlanUtilizationData): boolean {
        if (models.SavingsPlanBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, SavingsPlanUtilizationData.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.utilization_metrics) {
            models.SavingsPlanUtilizationMetricsData.fixupPrototype(this.utilization_metrics);
        }
    }

    /**
     * Paginated utilization time-series
     */
    utilization_metrics: models.SavingsPlanUtilizationMetricsData;

}
